import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { getLiveReportLinks } from "../../client/user/live-report";
import { LiveReportLink } from "../../models/live-report";

export const LIVE_REPORT_LINKS_QUERY_KEY = ["live-report", "viewer", "links"];

/**
 * Lists all active live report links the current logged-in user has access to.
 *
 * Polls every 30 seconds while the tab is visible, so a viewer notices revocations
 * within ~30s. Stops polling in the background to avoid wasted requests.
 */
export function useLiveReportLinks(): UseQueryResult<LiveReportLink[], Error> {
  return useQuery({
    queryKey: LIVE_REPORT_LINKS_QUERY_KEY,
    queryFn: getLiveReportLinks,
    staleTime: 15_000,
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });
}
